export default __webpack_public_path__ + "static/media/cup.7e565bca.svg";